import { ActionsUnion, createAction } from 'spw-redux/types';
import { MeasurementSystem } from 'spw-components/unit-conversion/types';
import { IUser, UpdateUserAvatarFields } from './types';

export const FETCH_USER = 'user/FETCH_USER';
export const FETCH_USER_SUCCEEDED = 'user/FETCH_USER_SUCCEEDED';

export const UPDATE_USER_AVATAR = 'user/UPDATE_USER_AVATAR';
export const UPDATE_USER_AVATAR_SUCCEEDED = 'user/UPDATE_USER_AVATAR_SUCCEEDED';

export const SET_MEASUREMENT_SYSTEM = 'user/SET_MEASUREMENT_SYSTEM';

export const CHANGE_MEASUREMENT_SYSTEM = 'user/CHANGE_MEASUREMENT_SYSTEM';

export const fetchUser = () => createAction(FETCH_USER);

export const setMeasurementSystem = (system: MeasurementSystem) =>
  createAction(SET_MEASUREMENT_SYSTEM, system);

export const changeMeasurementSystem = (system: MeasurementSystem) =>
  createAction(CHANGE_MEASUREMENT_SYSTEM, system);

export const fetchUserSucceeded = (user: IUser) =>
  createAction(FETCH_USER_SUCCEEDED, { user });

export const updateUserAvatar = (params: {
  form: UpdateUserAvatarFields;
  onSuccess?: () => void;
}) => createAction(UPDATE_USER_AVATAR, params);

export const updateUserAvatarSucceeded = (user: {
  id: number;
  hasAvatar: boolean;
  thumbnailS3Path: string;
}) => createAction(UPDATE_USER_AVATAR_SUCCEEDED, user);

export const actions = {
  fetchUser,
  fetchUserSucceeded,
  updateUserAvatar,
  updateUserAvatarSucceeded,
  setMeasurementSystem,
  changeMeasurementSystem,
};

export type Actions = ActionsUnion<typeof actions>;
